import React, { useCallback, useEffect, useRef, useState } from 'react'
import styles from "../css/FilterMenu.module.css"
import colors from "../../../data/colors.json"
import { TbSelector } from 'react-icons/tb';
import TagMenu from './TagMenu';
import { useDispatch } from 'react-redux';
import { TAG_RESET } from '../../../actions/tagTypes';
import { createPortal } from 'react-dom';

const FilterMenu = ({filterParams,onChangeFilterParams,closeMenu}) => {
    const [paramsCopy,setParamsCopy] = useState({...filterParams})
    const [showTags,setShowTags] = useState(false)
    const filterMenu = useRef(null)
    const dispatch = useDispatch()

    useEffect(()=>{
        const handleClick = (e) => {
            let tagMenu = document.getElementById("tag-filter-menu")
            if (tagMenu && tagMenu.contains(e.target)){
                return
            }
            if (filterMenu.current && filterMenu.current?.parentNode){
                if (!filterMenu.current?.parentNode?.contains(e.target)){
                    closeMenu()
                }
            }
        }
        window.addEventListener("mousedown",handleClick)

        return () => {
            window.removeEventListener("mousedown",handleClick)
        }
    },[closeMenu])

    const addTag = (tag) => {
        if (paramsCopy.tags.length === 4){
            closeTagMenu()
        }
        setParamsCopy((prevState)=>{
            let tags = [...paramsCopy.tags]
            tags.push(tag)
            return {...prevState,tags:tags}
        })
    }

    const deleteTag = (tag_id) => {
        setParamsCopy((prevState)=>{
            let tags = [...prevState.tags]
            tags = tags.filter(tag => tag._id !== tag_id)
            return {...prevState,tags:tags}
        })
    }

    const selectColor = (color) => {
        if (paramsCopy.color?.code === color.code){
            setParamsCopy({...paramsCopy,color:null})
        }
        else{
            setParamsCopy({...paramsCopy,color:color})
        }
    }

    const reset = () => {
        onChangeFilterParams({color:null,tags:[]})
        closeMenu()
    }

    const apply = () => {
        onChangeFilterParams({...paramsCopy})
        closeMenu()  
    }

    const setMenu = useCallback((el)=>{
        if (el){
            filterMenu.current = el
        }
    },[])

    const openTagMenu = () => {
        dispatch({type: TAG_RESET})
        setShowTags(true)
    }

    const closeTagMenu = () => {
        setShowTags(false)
        dispatch({type: TAG_RESET})
    }

    const handleTagMenu = () => {
        if (showTags){
            closeTagMenu()
        }
        else{
            openTagMenu()
        }
    }

    return (
        <div data-testid = "filter-menu" className = {styles.dropdown} ref = {setMenu}>
            <div className={styles.header}>Filter by</div>
            <div className = {styles.body} onScroll = {()=>closeTagMenu()}>
                <div className={styles.section}>
                    <div className={styles.sectionTop}>
                    <div className={styles.sectionLabel}>Color</div>
                    <button className={styles.reset} onClick = {()=>setParamsCopy({...paramsCopy,color:null})}>Reset</button>
                    </div>
                    <div className={styles.colors}>
                        {colors.map((color,index)=>(
                            <div
                                data-testid = {`color-${color.name}`}
                                key = {index} 
                                className = {`${styles.swatch} ${color.code === paramsCopy.color?.code ? styles.active : ""}`}
                                style={{ 
                                    background: color.code,
                                    boxShadow: paramsCopy.color?.code === color.code
                                    ? `0 0 0 2px ${color.code}, 0 0 0 4px #fff, 0 0 0 6px ${color.code}`
                                    : "none" }}
                                onClick = {()=>selectColor(color)}
                            >
                            </div>
                        ))}
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.sectionTop}>
                        <div className={styles.sectionLabel}>
                            Tags <span>(max 5)</span>
                        </div>
                        <button className={styles.reset} onClick = {()=>setParamsCopy({...paramsCopy,tags:[]})}>Reset</button>
                    </div>
                    <div className = {styles.menuWrapper}>
                        <button id = "tag-filter-btn" data-testid = "tag-btn" className={`${styles.tagTrigger} ${showTags ? styles.open : ""}`} onClick = {()=>handleTagMenu()}>
                            <div className={styles.tagTriggerLeft}>
                                <div className={styles.tagTriggerPills}>
                                    {paramsCopy.tags.map((tag)=>(
                                        <span data-testid = {`selected-tag-${tag._id}`} className={styles.tagTriggerPill} key = {tag._id}>{tag.name}</span>
                                    ))}
                                    {paramsCopy.tags.length === 0 && <span className = {styles.placeholder}>Select Tags</span>}
                                </div>
                            </div>
                            <span className={styles.tagTriggerArrow}><TbSelector/></span>
                        </button>
                        {showTags && 
                            createPortal(<TagMenu
                                selectedTags = {paramsCopy.tags}
                                addTag =  {addTag}
                                removeTag = {deleteTag}
                                closeMenu =  {()=>closeTagMenu()}
                                modal = "tag-filter-menu"
                            />,document.body)
                        }
                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <button type = "button" className={styles.resetAll} onClick = {()=>reset()}>Reset all</button>
                <button data-testid = "submit-btn" type = "button" className={styles.apply} onClick = {()=>apply()}>Apply →</button>
            </div>
        </div>
  )
}
export default FilterMenu